import { SubscriptionCoreBase } from "./subscription.core.base"


export class SubscriptionCore extends SubscriptionCoreBase {

}